export default __webpack_public_path__ + "static/media/015-pedal boat.cdafdbd0.svg";